import StarIcon from 'components/design-system/kickoff-icons-v2/star-icon'
import s from './styles.module.css'
import cn from 'classnames'

export default function InsurancePaymentGuaranteeCard({
  text,
  lgKey,
  className = '',
}: {
  text?: string
  lgKey?: string
  className?: string
}) {
  return (
    <div className={cn(s.guaranteeCard, className)}>
      <StarIcon className={s.starIcon} lgKey={lgKey} />
      <div className={s.guaranteeCardText}>
        <span>Kickoff Guarantee: </span>
        {text ||
          "You will pay nothing for this appointment. If insurance fails to cover the expense, we'll cover it!"}
      </div>
    </div>
  )
}
